import _createClass from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
var CsvError = /*#__PURE__*/function (_Error) {
  _inherits(CsvError, _Error);
  var _super = _createSuper(CsvError);
  function CsvError(code, message, options) {
    var _this;
    _classCallCheck(this, CsvError);
    if (Array.isArray(message)) message = message.join(' ').trim();
    _this = _super.call(this, message);
    if (Error.captureStackTrace !== undefined) {
      Error.captureStackTrace(_assertThisInitialized(_this), CsvError);
    }
    _this.code = code;
    for (var _len = arguments.length, contexts = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      contexts[_key - 3] = arguments[_key];
    }
    for (var _i = 0, _contexts = contexts; _i < _contexts.length; _i++) {
      var context = _contexts[_i];
      for (var key in context) {
        var value = context[key];
        _this[key] = Buffer.isBuffer(value) ? value.toString(options.encoding) : value == null ? value : JSON.parse(JSON.stringify(value));
      }
    }
    return _this;
  }
  return _createClass(CsvError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export { CsvError };